import { I18n } from "react-redux-i18n";
import { formatApproverInfo } from "../../util/FormatUtil";
import { getPersonTransportPermState, PERSON_TRANSPORT_PERM_STATES } from "./getPersonTransportPermState";

export const personTransportPermStatus = (applicant, isTeacher) => {
  const {
    personTransportPerm,
    personTransportPermApproved,
    personTransportApproveDate,
    personTransportApprover,
    personTransportLessonsCompleted,
  } = applicant;
  
  const state = getPersonTransportPermState(personTransportLessonsCompleted, personTransportPerm, personTransportPermApproved);
  
  let label = I18n.t("applicant.person_transport_perm_not_eligible");
  let disabledInfo = I18n.t(
    "applicant.person_transport_perm_disabled_not_eligible"
  );
  if (state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_APPROVED) {
    const labelParts = [I18n.t("applicant.person_transport_perm_approved")];
    if (personTransportPerm) {
      // Teacher has approved in KULTU (or KULTI)
      const approverInfo = formatApproverInfo(personTransportApproveDate, personTransportApprover);
      labelParts.push(approverInfo);
    }
    disabledInfo = I18n.t("applicant.person_transport_perm_disabled_kulti_already_approved")
    label = labelParts.join(", ");
  } else if (state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_RECOMENDED) {
    const labelParts = [I18n.t("applicant.person_transport_perm_waiting_approval")];
    if (personTransportPerm) {
      // Teacher has approved in KULTU (or KULTI)
      const approverInfo = formatApproverInfo(personTransportApproveDate, personTransportApprover);
      labelParts.push(approverInfo);
    }
    
    label = labelParts.join(", ");
  } else if (state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_ELIGIBLE) {
    label = I18n.t("applicant.person_transport_perm_eligible");  
  } else /*if (state === PERSON_TRANSPORT_PERM_STATES.PERSON_TRANSPORT_PERM_NOT_ELIGIBLE)*/ {
    label = I18n.t("applicant.person_transport_perm_not_eligible");
      disabledInfo = I18n.t(
        "applicant.person_transport_perm_disabled_not_eligible"
      );
  }

  if (!isTeacher) {
    disabledInfo = I18n.t(
      "applicant.person_transport_perm_disabled_not_teacher"
    );
  }

  // should edit checkbox be checked
  const hasPermission = !!personTransportPerm || !!personTransportPermApproved;
  // should edit checkbox be disabled
  const disabled = !isTeacher || !personTransportLessonsCompleted || !!personTransportPermApproved
  return {
    hasPermission,
    label,
    disabled: disabled,
    disabledInfo: disabled ? disabledInfo : "",
  };
};



// WEBPACK FOOTER //
// ./src/components/applicant/personTransportPermStatus.js